import React from 'react';
import './style.css';

export class Hotel extends React.Component {
    render() {
        return (
            <div id="hotel-screen">
                <div className="hotel-container">
                    <div className="hotel-travel-container">
                        <div className="hotel-public-transportation-container">
                            <div className="hotel-public-transportation-content-container">
                                <div className="hotel-public-transportation-content">
                                    IN CA. 5 MINUTEN FUSSWEG ERREICHST DU DIE S-BAHN IN SCHORNDORF (S2)
                                </div>
                            </div>
                            {/* <div className="hotel-public-transportation-link">Button</div> */}
                            <button
                                className="calender-entry-button"
                                onClick={() =>
                                    window
                                        .open(
                                            'https://www3.vvs.de/mng/#!/XSLT_TRIP_REQUEST2@init?language=de',
                                            '_blank'
                                        )
                                        ?.focus()
                                }
                            >
                                ICH LASS DAS AUTO STEHEN!
                            </button>
                        </div>
                        <div className="hotel-content-container">
                            <div className="hotel-content">
                                BEI BEDARF FINDEN SICH AUCH FOLGENDE UNTERKÜNFTE IN DER NÄHE
                            </div>
                            <a
                                className="hotel-link"
                                rel="noopener noreferrer"
                                href="https://www.hotel-reich.de/"
                                target="_blank"
                            >
                                <div className="hotel-link-content">HOTEL REICH AN DER REMS</div>
                            </a>
                            <a
                                className="hotel-link"
                                rel="noopener noreferrer"
                                href="https://www.hotel-stadtmauer.com/"
                                target="_blank"
                            >
                                <div className="hotel-link-content">HOTEL AN DER STADTMAUER</div>
                            </a>
                            <a
                                className="hotel-link"
                                rel="noopener noreferrer"
                                href="https://pfauen-schorndorf.de/"
                                target="_blank"
                            >
                                <div className="hotel-link-content">HOTEL PFAUEN</div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
